export default __webpack_public_path__ + "static/media/guia-mobile-dark-2.99ac692f.png";